import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["colspan"]
const _hoisted_2 = {
  key: 0,
  class: "form-group mb-0"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "align-top" }
const _hoisted_6 = {
  key: 0,
  class: "form-group mb-0"
}
const _hoisted_7 = { class: "input-group date datepickerInput" }
const _hoisted_8 = ["value"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_10 = {
  key: 1,
  class: "form-group mb-0"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "input-group date" }, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "text",
    class: "form-control",
    placeholder: "MM/DD/YYYY",
    autocomplete: "off",
    disabled: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_12 = { class: "form-check custom-checkbox form-check-inline" }
const _hoisted_13 = ["id"]
const _hoisted_14 = ["for"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "Unknown", -1 /* HOISTED */)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "align-top" }
const _hoisted_19 = {
  key: 0,
  class: "form-group mb-0"
}
const _hoisted_20 = { class: "input-group date datepickerInput" }
const _hoisted_21 = ["value"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_23 = { class: "form-group mb-0" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "input-group date" }, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "text",
    class: "form-control",
    placeholder: "MM/DD/YYYY",
    autocomplete: "off",
    disabled: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_25 = { class: "form-check custom-checkbox form-check-inline" }
const _hoisted_26 = ["id"]
const _hoisted_27 = ["for"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "Unknown", -1 /* HOISTED */)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { key: 0 }
const _hoisted_31 = {
  key: 0,
  class: "text-end"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1 /* HOISTED */)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1 /* HOISTED */)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  key: 0,
  class: "btn-group table-btn-group"
}
const _hoisted_37 = ["id"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-h" }, null, -1 /* HOISTED */)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = ["aria-labelledby"]
const _hoisted_41 = ["colspan"]
const _hoisted_42 = { class: "d-flex flex-column align-items-center" }
const _hoisted_43 = {
  key: 3,
  class: "button-cell text-end"
}
const _hoisted_44 = {
  key: 4,
  class: "button-cell text-end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Diagnosis = _resolveComponent("Diagnosis")!
  const _component_EmptyTextHandler = _resolveComponent("EmptyTextHandler")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_TablePrompt = _resolveComponent("TablePrompt")!

  return (_openBlock(), _createElementBlock("tr", {
    class: _normalizeClass(`${_ctx.isEditRequested || _ctx.isAddRequested || _ctx.isDeleteRequested ? 'edit-row' : ''}`)
  }, [
    _createElementVNode("td", {
      colspan: ` ${_ctx.isEditRequested || _ctx.isAddRequested ? '2' : '1'}`,
      class: "align-top"
    }, [
      (_ctx.isEditRequested || _ctx.isAddRequested)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_Diagnosis, {
              "selected-diagnosis": _ctx.selectedDiagnosis,
              "diagnosis-changed": _ctx.diagnosisChanged,
              application: Number(_ctx.application)
            }, null, 8 /* PROPS */, ["selected-diagnosis", "diagnosis-changed", "application"])
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, [
            _createVNode(_component_EmptyTextHandler, {
              text: _ctx.diag.code
            }, null, 8 /* PROPS */, ["text"])
          ]))
    ], 8 /* PROPS */, _hoisted_1),
    (!_ctx.isEditRequested && !_ctx.isAddRequested)
      ? (_openBlock(), _createElementBlock("td", _hoisted_4, [
          _createVNode(_component_EmptyTextHandler, {
            text: _ctx.diag.description
          }, null, 8 /* PROPS */, ["text"])
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("td", _hoisted_5, [
      (_ctx.isEditRequested || _ctx.isAddRequested)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (!_ctx.diag.isStartDateUnknown)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_DatePicker, { getDate: _ctx.handleDateChange }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("input", {
                          name: "startDate",
                          type: "text",
                          class: "form-control",
                          placeholder: "MM/DD/YYYY",
                          value: _ctx.formatDateInput(_ctx.diag.startDate),
                          autocomplete: "off",
                          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDate && _ctx.handleDate(...args)))
                        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_8),
                        _hoisted_9
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["getDate"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_DatePicker, null, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1 /* STABLE */
                  })
                ])),
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "form-check-input au-target",
                id: `diag-start-${_ctx.currentView}-${_ctx.index}`,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.diag.isStartDateUnknown) = $event))
              }, null, 8 /* PROPS */, _hoisted_13), [
                [_vModelCheckbox, _ctx.diag.isStartDateUnknown]
              ]),
              _createElementVNode("label", {
                class: "form-check-label",
                for: `diag-start-${_ctx.currentView}-${_ctx.index}`
              }, _hoisted_16, 8 /* PROPS */, _hoisted_14)
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.diag.isStartDateUnknown)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Unknown"))
              : (_openBlock(), _createBlock(_component_EmptyTextHandler, {
                  key: 1,
                  text: _ctx.formatDate(_ctx.diag.startDate)
                }, null, 8 /* PROPS */, ["text"]))
          ], 64 /* STABLE_FRAGMENT */))
    ]),
    _createElementVNode("td", _hoisted_18, [
      (_ctx.isEditRequested || _ctx.isAddRequested)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (!_ctx.diag.isResolvedDateUnknown)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createVNode(_component_DatePicker, { getDate: _ctx.handleDateChange }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("input", {
                          name: "resolvedDate",
                          type: "text",
                          class: "form-control",
                          placeholder: "MM/DD/YYYY",
                          value: _ctx.formatDateInput(_ctx.diag.resolvedDate),
                          autocomplete: "off",
                          onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleDate && _ctx.handleDate(...args)))
                        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_21),
                        _hoisted_22
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["getDate"])
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createCommentVNode(" Added this extra div to show disabled so that validation would also be hidden "),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_DatePicker, null, {
                      default: _withCtx(() => [
                        _hoisted_24
                      ]),
                      _: 1 /* STABLE */
                    })
                  ])
                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
            _createElementVNode("div", _hoisted_25, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "form-check-input au-target",
                id: `diag-resolved-${_ctx.currentView}-${_ctx.index}`,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.diag.isResolvedDateUnknown) = $event))
              }, null, 8 /* PROPS */, _hoisted_26), [
                [_vModelCheckbox, _ctx.diag.isResolvedDateUnknown]
              ]),
              _createElementVNode("label", {
                class: "form-check-label",
                for: `diag-resolved-${_ctx.currentView}-${_ctx.index}`
              }, _hoisted_29, 8 /* PROPS */, _hoisted_27)
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.diag.isResolvedDateUnknown)
              ? (_openBlock(), _createElementBlock("span", _hoisted_30, "Unknown"))
              : (_openBlock(), _createBlock(_component_EmptyTextHandler, {
                  key: 1,
                  text: _ctx.formatDate(_ctx.diag.resolvedDate)
                }, null, 8 /* PROPS */, ["text"]))
          ], 64 /* STABLE_FRAGMENT */))
    ]),
    (!_ctx.isDeleteRequested)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (!_ctx.isEditRequested && !_ctx.isAddRequested)
            ? (_openBlock(), _createElementBlock("td", _hoisted_31, [
                _createElementVNode("button", {
                  class: "btn table-btn btn-outline-info",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openEditDiagnosis()))
                }, _hoisted_33),
                _createElementVNode("button", {
                  class: "btn table-btn btn-outline-danger",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openDeleteDiagnosis()))
                }, _hoisted_35),
                (!_ctx.first || !_ctx.last)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn px-1 py-0 btn-outline-primary dropdown-toggle",
                        "data-bs-toggle": "dropdown",
                        id: `DiagnosisRow__Actions${_ctx.diag.order}`
                      }, _hoisted_39, 8 /* PROPS */, _hoisted_37),
                      _createElementVNode("div", {
                        class: "dropdown-menu",
                        "aria-labelledby": `DiagnosisRow__Action${_ctx.diag.order}`
                      }, [
                        (!_ctx.first)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "dropdown-item",
                              href: "javascript:void(0);",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.moveDiagnosisUp(_ctx.index, _ctx.index - 1)))
                            }, " Move up "))
                          : _createCommentVNode("v-if", true),
                        (!_ctx.last)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              class: "dropdown-item",
                              href: "javascript:void(0);",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.moveDiagnosisDown(_ctx.index, _ctx.index + 1)))
                            }, " Move down "))
                          : _createCommentVNode("v-if", true)
                      ], 8 /* PROPS */, _hoisted_40)
                    ]))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    (_ctx.isDeleteRequested)
      ? (_openBlock(), _createElementBlock("td", {
          key: 2,
          colspan: _ctx.columns,
          class: "p-2 edit"
        }, [
          _createElementVNode("div", _hoisted_42, [
            _createVNode(_component_TablePrompt, {
              "ok-text": "Delete",
              name: "delete",
              ok: _ctx.handleDeleteDiagnosis,
              cancel: _ctx.cancelDeleteRequest,
              message: _ctx.deleteMessage,
              "cancel-text": "No",
              "include-yes": false
            }, null, 8 /* PROPS */, ["ok", "cancel", "message"])
          ])
        ], 8 /* PROPS */, _hoisted_41))
      : _createCommentVNode("v-if", true),
    (_ctx.isEditRequested)
      ? (_openBlock(), _createElementBlock("td", _hoisted_43, [
          _createElementVNode("button", {
            type: "button",
            class: "btn table-btn btn-outline-success",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.saveEditDiagnosis()))
          }, "Add"),
          _createElementVNode("button", {
            type: "button",
            class: "btn table-btn btn-outline-secondary",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.cancelEditDiagnosis()))
          }, " Cancel ")
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.isAddRequested)
      ? (_openBlock(), _createElementBlock("td", _hoisted_44, [
          _createElementVNode("button", {
            type: "button",
            class: "btn table-btn btn-outline-success",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.save()))
          }, "Add"),
          _createElementVNode("button", {
            type: "button",
            class: "btn table-btn btn-outline-secondary",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.cancelSaveNewDiagnosis()))
          }, " Cancel ")
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}